export default {
    cta: "Demandez à An<br/> Conseiller",
    ordered: "Commandé le {date}"
}